module.exports = __webpack_public_path__ + "img/empty.1dc044cc.png";